import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/store'
import { setTitle } from 'reducers/activecourse/activecourseSlice'
import { CourseTabTitle } from 'share/domain/course'
import CourseTabPlaceOrderCreateAccountForm from 'components/organisms/CourseTabPlaceOrderCreateAccountForm'

const CourseTabPlaceOrderCreateAccount = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const activeCourse = useAppSelector((state) => state.activeCourse)
  const [courseName, setCourseName] = useState('first')

  useEffect(() => {
    let title = ''
    if (activeCourse?.activeTab) {
      title =
        activeCourse.activeTab === 'first'
          ? CourseTabTitle.TAKE_FIRST_COURSE
          : CourseTabTitle.TAKE_SECOND_COURSE
    }

    if (activeCourse?.activeTab === 'second') {
      setCourseName('second')
    }

    dispatch(setTitle(title))
  }, [activeCourse?.activeTab])

  return (
    <div>
      <h2>Verify Your Account Details</h2>
      <h4>
        Verify your information that will be used to create your {courseName}{' '}
        course order
      </h4>

      <CourseTabPlaceOrderCreateAccountForm />
    </div>
  )
}

export default CourseTabPlaceOrderCreateAccount
